import { makeStyles } from 'tss-react/mui';

const useOAuthConsentPanelStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  scopes: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  scopeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  scopeIcon: {
    display: 'inline-flex',
    color: theme.palette.primary.main,
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
}));

export default useOAuthConsentPanelStyles;
